import { render, staticRenderFns } from "./DesignView.vue?vue&type=template&id=802b4b48"
import script from "./DesignView.vue?vue&type=script&lang=js"
export * from "./DesignView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports